import React from "react";
import { Checkbox } from "@mui/material";
import { CheckSquare, Square } from "@phosphor-icons/react";

export const GenericCheckBox = ({ iconSize = 24, ...others }) => {
  return (
    <Checkbox
      {...others}
      icon={<Square size={iconSize} color="#919EAB" />}
      checkedIcon={<CheckSquare size={iconSize} weight="fill" />}
    />
  );
};